import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { CommonsModule } from '@core/components/commons/commons.module';
import { VersionsModule } from '@core/components/versions/versions.module';
import { VersionFilesModule } from '@core/components/versions/version-files/version-files.module';

import { AppRouterModule } from '@app/router.module';

import { BridgesFileComparisonProjectMainComponent } from './filecomparison/project/main/main.component';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        AppRouterModule,
        CommonsModule,
        VersionsModule,
        VersionFilesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        BridgesFileComparisonProjectMainComponent
    ],
    exports: [
        BridgesFileComparisonProjectMainComponent
    ],

})
export class BridgesModule { }
